import { render, staticRenderFns } from "./OpenSaleCard.vue?vue&type=template&id=de82fb4e&scoped=true"
import script from "./OpenSaleCard.vue?vue&type=script&lang=js"
export * from "./OpenSaleCard.vue?vue&type=script&lang=js"
import style0 from "./OpenSaleCard.vue?vue&type=style&index=0&id=de82fb4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de82fb4e",
  null
  
)

export default component.exports